import type { CodeResponse, OAuthParams } from '@rentflowdev/api'
import { clearOAuthState } from './oauth-params'

export function redirectWithCode(params: OAuthParams, result: CodeResponse): void {
	const url = new URL(params.redirectUri)
	url.searchParams.set('code', result.code)
	url.searchParams.set('state', result.state)
	clearOAuthState()
	window.location.href = url.toString()
}

export function redirectWithError(params: OAuthParams, error: string): void {
	const url = new URL(params.redirectUri)
	url.searchParams.set('error', error)
	url.searchParams.set('state', params.state)
	clearOAuthState()
	window.location.href = url.toString()
}
